export class Resource {  

    content:string;
    description: string;
    documents: File;
    image: File;
    
   


}